(() => {
  if (customElements.get("cart-drawer")) {
    return;
  }

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener("click", (e) => {
        const target = e.target;

        if (target.closest('[data-button]')) {
          e.preventDefault();
          this.open();
        }

        if (
          target.closest("[data-button-close]") ||
          target.hasAttribute("data-overlay")
        ) {
          e.preventDefault();
          this.close();
        }
      });
    }

    open() {
      this.setAttribute("open", "");
    }

    close() {
      this.removeAttribute("open");
    }
  }

  customElements.define("cart-drawer", CartDrawer);
})();
